import { useHistory } from 'react-router';
import { useEffect } from 'react';
import { getDatasetUrlParams } from '../../../utils/getDatasetUrlParams';
import { useSelectedRowsContext } from '../../../hooks/context/useSelectedRowsContext';

export const useFilterBackButtonGuard = () => {
  const history = useHistory();
  const { setExpandedRow } = useSelectedRowsContext();

  useEffect(() => {
    const unblock = history.block((target, action) => {
      if (action === 'POP') {
        const from = getDatasetUrlParams(history.location.pathname);
        const to = getDatasetUrlParams(target.pathname);

        if (
          to.datasetId !== undefined &&
          to.itemId !== undefined &&
          from.datasetId === to.datasetId
        ) {
          setExpandedRow(null);

          const isObject = typeof target.state === 'object';
          target.state = {
            ...((isObject ? target.state : {}) as Record<string, unknown>),
            forceFindInDataset: true,
          };
        }
      }

      return undefined;
    });

    return unblock;
  }, [history]);
};
